<template>
  <ul class="menu" v-if="isPortalTypeBooks">
    <li>
      <a
        :href="$getSubdomainLink('portal', '/books/catalog')"
        class="menu__item"
        :class="{
          active: $route.path.includes('/books/catalog'),
        }"
      >
        Books
      </a>
    </li>
  </ul>
  <ul class="menu" v-else>
    <li>
      <a
        :href="$getSubdomainLink('portal', '/video/catalog')"
        class="menu__item"
        :class="{
          active: $route.path.includes('/video/catalog'),
        }"
      >
        Inspiration
      </a>
    </li>
    <li>
      <a
        :href="$getSubdomainLink('portal', '/planner')"
        class="menu__item"
        :class="{
          active: $route.path.includes('/planner'),
        }"
      >
        Planner
      </a>
    </li>
    <li>
      <a
        :href="$getSubdomainLink('portal', '/books/catalog')"
        class="menu__item"
        :class="{
          active: $route.path.includes('/books/catalog'),
        }"
      >
        Books
      </a>
    </li>
    <li>
      <a
        :href="$getSubdomainLink('portal', '/blog/catalog')"
        class="menu__item"
        :class="{
          active: $route.path.includes('/blog/catalog'),
        }"
      >
        Blog
      </a>
    </li>
  </ul>
</template>

<script>
import { useEnabledStore } from "@/stores";
export default {
  data() {
    return {
      enabledStore: useEnabledStore(),
    };
  },
  computed: {
    isPortalTypeBooks() {
      return this.enabledStore.isPortalTypeBooks;
    },
  },
};
</script>
